import styled from "styled-components";

import { colorsPalettes } from "@similarweb/styles";
import { PopoverContent } from "@similarweb/ui-components";

export const StyledPopoverContent = styled(PopoverContent)`
    background-color: ${colorsPalettes.carbon[500]};
    color: ${colorsPalettes.carbon[0]};
`;
